import { useContext } from "react";
import { ManualOfflineContext } from "./ManualOfflineContext";
import { OnlineStatusContext } from "./OnlineStatusContext";

const OfflineWrapper = ({ children }) => {
  const { manualOffline } = useContext(ManualOfflineContext);
  const { isOnline } = useContext(OnlineStatusContext);

  if (manualOffline || !isOnline) {
    return children;
  }

  return null;
};

export default OfflineWrapper;
